import { ILogoutAction } from "../interfaces/auth.interface";

export function logoutSuccess(): ILogoutAction {
  return {
    type: "LOGOUT",
  };
}
